module.exports = __webpack_public_path__ + "static/assets/92e1139484e0d6be8f970228b6ba5320.png";